(function () {
    'use strict';

    /* @ngdoc object
     * @name authentication
     * @description
     *
     */
    angular
        .module('authentication', [
            'ui.router'
        ]);
}());
